import { useAuth } from "../lib/auth";
import { Link, useLocation } from "react-router-dom";
import { SignOut, Sparkle, ShieldCheck, Users } from "@phosphor-icons/react";

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  if (!user) return null;
  const isStaff = user.role === "teacher" || user.role === "assistant";
  const isAdmin = user.role === "teacher";
  return (
    <header className="sticky top-0 z-30 bg-[#FFFDF8]/85 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="header-home-link">
          <div className="w-9 h-9 rounded-2xl bg-yellow-400 flex items-center justify-center">
            <Sparkle weight="fill" className="text-yellow-950" size={20} />
          </div>
          <div className="hidden sm:block">
            <div className="font-outfit font-black leading-none">Alpha AI Discovery Club</div>
            <div className="text-[11px] text-slate-500">Class dashboard · Tema</div>
          </div>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          {location.pathname !== "/" && (
            <Link to="/" className="text-sm font-medium px-2 sm:px-3 py-2 rounded-lg hover:bg-slate-100" data-testid="header-dashboard-link">
              Dashboard
            </Link>
          )}
          {isStaff && (
            <Link
              to="/students"
              data-testid="header-students-link"
              className={`text-sm font-medium px-2 sm:px-3 py-2 rounded-lg inline-flex items-center gap-1 ${
                location.pathname === "/students" ? "bg-slate-900 text-white" : "hover:bg-slate-100"
              }`}
            >
              <Users size={14} weight="bold" /> <span className="hidden sm:inline">Students</span>
            </Link>
          )}
          {isAdmin && (
            <Link
              to="/admin"
              data-testid="header-admin-link"
              className={`text-sm font-medium px-2 sm:px-3 py-2 rounded-lg inline-flex items-center gap-1 ${
                location.pathname === "/admin" ? "bg-slate-900 text-white" : "hover:bg-slate-100"
              }`}
            >
              <ShieldCheck size={14} weight="bold" /> <span className="hidden sm:inline">Admin</span>
            </Link>
          )}
          <div className="flex items-center gap-2 sm:gap-3 pl-2 sm:pl-3 border-l border-slate-200">
            <div className="text-right hidden sm:block">
              <div className="font-outfit font-semibold text-sm leading-none" data-testid="header-user-name">{user.name}</div>
              <div className="text-[11px] text-slate-500 capitalize">{user.role}</div>
            </div>
            <img
              src={`https://api.dicebear.com/9.x/micah/svg?seed=${encodeURIComponent(user.name || user.email)}`}
              alt=""
              className="w-9 h-9 rounded-full bg-slate-100 border border-slate-200"
            />
            <button
              onClick={logout}
              data-testid="header-logout-btn"
              className="p-2 rounded-lg hover:bg-slate-100 text-slate-600"
              title="Sign out"
            >
              <SignOut size={18} />
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
